import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../actions'
import { Rechazo0, Rechazo1 } from './steps'
import { FORM_RECHAZO_EN_PLAYA } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'

const selector = formValueSelector(FORM_RECHAZO_EN_PLAYA)

class RechazoEnPlaya extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  nextStep () {
    const {
      verificarRechazoEnPlaya,
      rechazoStep,
      numero
    } = this.props

    if (rechazoStep === 0) {
      verificarRechazoEnPlaya(numero)
    }
  }

  prevStep () {
    this.props.rechazoPrevStep()
  }

  handleSubmit () {
    this.props.rechazarCpa(this.props.destroy)
  }

  render () {
    const {
      rechazoStep,
      showCircular
    } = this.props

    return (
      <div className='camiones-abandono-container'>
        <h2>Rechazo de CPE en Playa</h2>
        {rechazoStep === 0 && <Rechazo0 onSubmit={this.nextStep} />}
        {rechazoStep === 1 &&
          <Rechazo1 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <div>
          {showCircular
            ? <div style={{ padding: '12% 0', margin: '0 auto' }} >
              <div className='loader' />
              <h4 style={{ margin: '22px ', fontSize: '1.3rem' }}>Rechazando CPE en ARCA...</h4>
            </div>
            : null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    numero: selector(state, 'numero'),
    rechazoStep: state.camionesIngreso.rechazoStep,
    showCircular: state.camionesIngreso.showCircular
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({ form: FORM_RECHAZO_EN_PLAYA })(RechazoEnPlaya)
)
